import {Component, ElementRef, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {ConfService} from '../conf.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AddGatewayResourceComponent, LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {MethodTypes} from '../crudapi/crudapi.component';
import {KongService} from '../kong.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {WebsocketService} from '../websocket.service';
import {environment} from '../../environments/environment';

const incr = 7;

@Component({
    selector: 'app-promotion',
    templateUrl: './promotion.component.html',
    styleUrls: ['./promotion.component.scss']
})
export class PromotionComponent implements OnInit {
    migrateData = false;
    replaceApi = false;
    showStatusPanel = false;
    showResultsPage = false;
    deploymentResults: any;
    loading = false;
    target: string;
    targetAccount: string;
    entityPlans: any;
    entityTypes = [];
    entities: any;
    databases: any;
    selectedDatabase: string;
    selectedDatatypeFilter: any;
    dataTypeFilter: any;
    datatypes: any;

    @Input() partner: string;
    @Input() account: string;
    @Input() entity: string;
    @Input() version: string;
    type = 'DATAACCESS';
    progress = 0;
    progressMessage: string;
    entityToBePromoted: any;
    dependencies: any;
    targetPkey: String;

    targetEnvironments: any;

    // environments: MethodTypes[] = [
    //   {id: 'DEV', itemName: 'Development'},
    //   {id: 'QA', itemName: 'QA'},
    //   {id: 'STAGING', itemName: 'Staging'},
    //   {id: 'PROD', itemName: 'Production'}
    // ];

    environments = [];
    checkAuthenticityAndGetDatabasesCompleted = false;
    gatewayRoute = {
        data: []
    };
    APIName: any;
    APIVersion: any;
    targetDatabases = [];
    isAPIAlreadyExists: boolean;
    existingAPI: any;
    manageProgressId: any;
    componentLoading = true;
    apiDependenciesList = [];
    apiDeploymentStatus = [];
    timeStamp: any;
    action: any;
    renderType: any;
    targetPartnerEmail = localStorage.getItem('signInEmail');
    partnerDatabases: any;
    tabData = [];
    renderedDataAccessAPIs = [];
    activeTabIndex = 0;

    deniedPermission = '';

    constructor(private route: ActivatedRoute,
                private confPost: ConfService,
                private websocketService: WebsocketService,
                private kong: KongService, public router: Router, public dialog: MatDialog,
                public platform: LeftpanelComponent) {
    }

    manageProgress() {
        if (this.progress === 98) {
            this.platform.openSnackBar('API Promoted Successfully.', 'Success', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
        if (this.progress > 100) {
            this.showStatusPanel = false;
            clearInterval(this.manageProgressId);
            // this.showResultsPage = true;
        } else {
            this.progress = this.progress + incr;
        }
        if (this.progress <= 35) {
            this.progressMessage = 'Setting Up API';
        } else if (this.progress > 35 && this.progress <= 70) {
            this.progressMessage = 'Setting Up Database';
            /*} else if (this.progress > 70 && this.progress <= 98) {
                this.progressMessage = 'Creating dedicated File storage for your account';*/
        } else if (this.progress > 70) {
            this.progressMessage = 'Deploying into Cloud';
        }
    }

    getDatabaseTypeForDatabaseName(val) {
        // if (this.databases.hasOwnProperty('databaseDetails')) {
        //   this.databases.databaseDetails.filter(items => {
        //     if (items.database_name === val) {
        //       this.selectedDatatypeFilter = items.database_type;
        //     }
        //   });
        // } else {
        this.databases.filter(items => {
            if (items.database_name === val) {
                this.selectedDatatypeFilter = items.database_type;
            }
        });
        return this.selectedDatatypeFilter;
        // }
    }

    getEntitiesForPartnerAccount(partner, account) {
        this.confPost.getEntitiesForPartnerAccount(partner, account).subscribe(data => {
            this.entities = data;
            this.entities.forEach(entity => {
                this.entityTypes.push(entity.entityname + '_' + entity.version);
            });
        });
    }

    async ngOnInit() {

        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }

        const temp = localStorage.getItem('partner').split('-');
        let partnerShortCode = '';
        let currentEnvironment = '';
        if (temp.length > 1) {
            partnerShortCode = temp[temp.length - 1];
            currentEnvironment = temp[0];
        } else {
            partnerShortCode = temp[0];
            currentEnvironment = 'prod';
        }

        if (this.platform.adminSettingsData && this.platform.adminSettingsData !== null && this.platform.adminSettingsData !== undefined) {
            const envs = this.platform.adminSettingsData['body'][0]['environments'];
            for (const env of envs) {
                if (env && env !== null && env !== undefined) {
                    if (env['type'] !== currentEnvironment && env['type'] !== 'admin') {
                        this.environments.push(env['name']);
                    }
                }
            }
        } else {
            this.confPost.getSettingsV2CRUD('admin-' + partnerShortCode, 'admin-' + partnerShortCode, false).subscribe(response => {
                if (response['body'] && response['body'][0]) {
                    this.platform.adminSettingsData = response;
                    const envs = this.platform.adminSettingsData['body'][0]['environments'];
                    for (const env of envs) {
                        if (env && env !== null && env !== undefined) {
                            if (env['type'] !== currentEnvironment && env['type'] !== 'admin') {
                                this.environments.push(env['name']);
                            }
                        }
                    }
                }
            }, error => {
                this.platform.openSnackBar(error.error.message, 'Error', {
                    duration: 15000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        }

        await this.route.queryParams
            .subscribe(async params => {
                this.partner = params.partner;
                this.account = params.account;
                this.entity = params.entity;
                this.version = params.version;
                this.type = params.type;
                const env = JSON.parse(params.env);
                this.target = env.targetEnvironment;
                this.targetPkey = env.targetPkey;
                if (env.targetAccount) {
                    this.targetAccount = env.targetAccount;
                    await this.getTargetPartner();
                    this.renderType = 'copyAPI';
                } else {
                    this.targetAccount = env.targetEnvironment;
                    this.renderType = 'promoteAPI';
                }
                this.componentLoading = true;
                //await this.getEntityOrExecutors();
                const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                    maxWidth: '95vw',
                    maxHeight: '60vh',
                });
                await this.getPartnerDatabases(loaderDialog);
                this.componentLoading = false;
            });
    }

    getTargetPartner() {
        return new Promise((resolve, reject) => {
            this.confPost.getPartnerWithPkey(this.target, this.targetAccount, this.targetPkey).subscribe(partnerResponse => {
                if (partnerResponse) {
                    this.targetPartnerEmail = partnerResponse['primary_email'];
                    resolve('success');
                } else {
                    this.platform.openSnackBar('Error while retrieving Target Partner. Please try again after sometime', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    //this.dialogRef.close();
                    resolve('failed');
                }
            }, error => {
                this.platform.openSnackBar('Error while retrieving Target Partner. Please try again after sometime', 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                //this.dialogRef.close();
                resolve('failed');
            });
        });
    }

    getEntityOrExecutors() {
        return new Promise((resolve, reject) => {
            if (this.type === 'DATAACCESS') {
                this.confPost.getEntity(this.partner, this.account, this.entity, this.version).subscribe(async result => {
                    if (result) {
                        this.entityToBePromoted = result;
                        await this.getGatewayItems(this.entityToBePromoted, false);
                        await
                            this.getEntitiesForPartnerAccount(this.partner, this.account);

                        if (this.platform.datatypes !== null && this.platform.datatypes !== undefined) {
                            this.datatypes = this.platform.datatypes;
                        } else {
                            await this.confPost.getDataTypes().toPromise().then(data => {
                                    this.datatypes = data;
                                    this.platform.datatypes = data;
                                },
                                error => {
                                    this.platform.handleErrorGracefully(error, 'Error while getting list of data types. Please try again after sometime.');
                                });
                        }

                        if (this.platform.databases !== null && this.platform.databases !== undefined) {
                            this.databases = this.platform.databases;
                        } else {
                            await this.confPost.getDatabases(localStorage.getItem('partner')).toPromise().then(async databases => {
                                    await this.platform.updateIsNoSQLForMongo(databases);
                                    this.databases = this.platform.databases;
                                },
                                error => {
                                    this.platform.handleErrorGracefully(error, 'Error while getting list of databases. Please try again after sometime.');
                                });
                        }
                        this.getDatabaseTypeForDatabaseName(this.entityToBePromoted['database']);
                        this.dataTypeFilter = [];
                        this.datatypes.filter(items => {
                            if (items.database_type === this.selectedDatatypeFilter) {
                                this.dataTypeFilter.push(items);
                            }
                        });
                        if (this.selectedDatatypeFilter === 'mongodb') {
                            this.entityTypes.forEach(entityType => {
                                const newType = {
                                    'database_type': 'mongodb',
                                    'data_types': [
                                        {
                                            'type': entityType,
                                            'default_length': '',
                                            'min_length': '',
                                            'max_length': ''
                                        }]
                                };
                                this.dataTypeFilter.push(newType);
                            });
                        }

                        // this.confPost.getDatabases(this.partner).subscribe(databases => {
                        //   this.databases = databases;
                        //   this.getDatabaseTypeForDatabaseName(this.selectedDatabase !== null ? this.selectedDatabase : 'default');
                        //   this.confPost.getDataTypes().subscribe(data => {
                        //     this.datatypes = data;
                        //     this.dataTypeFilter = [];
                        //     this.datatypes.filter(items => {
                        //       if (items.database_type === this.selectedDatatypeFilter ) {
                        //         this.dataTypeFilter.push(items);
                        //       }
                        //     });
                        //     if (this.selectedDatatypeFilter === 'mongodb') {
                        //       this.entityTypes.forEach(entityType => {
                        //         const newType = {'database_type': 'mongodb',
                        //           'data_types': [
                        //             {'type': entityType,
                        //               'default_length': '',
                        //               'min_length': '',
                        //               'max_length': ''
                        //             }]};
                        //         this.dataTypeFilter.push(newType);
                        //       });
                        //     }
                        //   });
                        // });
                        resolve('success');
                    } else {
                        this.platform.openSnackBar('Error retrieving API with name: ' + this.entity + ' and version: ' + this.version, 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        this.router.navigateByUrl('/controlplane');
                        resolve('failed');
                    }

                }, error => {
                    this.platform.handleErrorGracefully(error, 'There is no API available in this account with this name: ' + this.entity + ' and this version: ' + this.version);
                    this.router.navigateByUrl('/controlplane');
                    resolve('failed');
                });
            } else {
                this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account, this.entity, this.version).subscribe(async result => {
                    if (result) {
                        this.entityToBePromoted = result;
                        if (this.type === 'SQLQUERY') {
                            if (this.platform.databases !== null && this.platform.databases !== undefined) {
                                this.databases = this.platform.databases;
                            } else {
                                await this.confPost.getDatabases(localStorage.getItem('partner')).toPromise().then(async databases => {
                                        await this.platform.updateIsNoSQLForMongo(databases);
                                        this.databases = this.platform.databases;
                                    },
                                    error => {
                                        this.platform.handleErrorGracefully(error, 'Error while getting list of databases. Please try again after sometime.');
                                    });
                            }
                            this.getDatabaseTypeForDatabaseName(this.entityToBePromoted['executors'][0]['database']['databaseDetails']['database_name']);
                        }
                        await this.getGatewayItems(this.entityToBePromoted, true);
                        resolve('success');
                    } else {
                        this.platform.openSnackBar('Error retrieving API with name: ' + this.entity + ' and version: ' + this.version, 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        this.router.navigateByUrl('/controlplane');
                        resolve('failed');
                    }
                }, error => {
                    this.platform.handleErrorGracefully(error, 'There is no API available in this account with this name: ' + this.entity + ' and this version: ' + this.version);
                    this.router.navigateByUrl('/controlplane');
                    resolve('failed');
                });
            }
        });
    }

    getPartnerDatabases(loaderDialog: MatDialogRef<LoaderWithProgressComponent>) {
        this.targetDatabases = [];
        return new Promise((resolve, reject) => {
            this.confPost.getDatabasesForPartner(this.target, this.targetPkey).subscribe(response1 => {
                if (response1 && response1 !== null && response1 !== undefined && response1.status && response1.status === 200) {
                    if (response1.body && response1.body !== null && response1.body !== undefined) {
                        if (response1.body && response1.body !== null && response1.body !== undefined) {
                            let databases: any;
                            this.partnerDatabases = response1.body;
                            this.partnerDatabases.forEach(db => {
                                if (db && db !== null && db !== undefined) {
                                    if (db['database_type'] === this.selectedDatatypeFilter) {
                                        this.targetDatabases.push(db);
                                    }
                                }
                            });
                            loaderDialog.close();
                            resolve('success');
                        } else {
                            resolve('failed');
                        }
                    } else {
                        resolve('failed');
                    }
                } else {
                    resolve('failed');
                }
            }, error => {
                resolve('failed');
                loaderDialog.close();
                this.platform.handleErrorGracefully(error, 'Error while retrieving target partner\'s databases.');
            });
        });
    }

    checkForExistingTable() {
        return new Promise((resolve, reject) => {
            this.confPost.checkIfTableExistsForpartner(this.target, this.targetPkey, this.entityToBePromoted['tableName'], this.entityToBePromoted['database'], this.entityToBePromoted['databaseType']).subscribe(response => {
                if (response && response !== undefined && response !== null) {
                    this.platform.openSnackBar('There is a table already present in the target partner.', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.router.navigateByUrl('/controlplane');
                } else {
                    resolve('success');
                }
            }, error => {
                this.platform.openSnackBar('Error while checking the table existence in target partner. Please try again after sometime', 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.router.navigateByUrl('/controlplane');
            });
        });
    }

    checkAuthenticityAndGetDatabasesOnFocusOut() {
        setTimeout(() => {
            this.checkAuthenticityAndGetDatabases();
        }, 1000);
    }

    checkAuthenticityAndGetDatabases() {
        return new Promise((resolve, reject) => {
            if (this.checkAuthenticityAndGetDatabasesCompleted === false) {
                if (this.target && this.target !== null && this.target !== undefined && this.target !== '' && this.targetPkey && this.targetPkey !== null && this.targetPkey !== undefined && this.targetPkey !== '') {
                    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                        maxWidth: '95vw',
                        maxHeight: '60vh',
                    });
                    this.checkAuthenticityAndGetDatabasesCompleted = true;
                    this.confPost.authorizePartner(this.target, this.targetPkey).subscribe(response => {
                        if (response.status === 200) {
                            if (this.type === 'DATAACCESS') {
                                this.APIName = this.entityToBePromoted.entityname;
                                this.APIVersion = this.entityToBePromoted.version;
                            } else {
                                this.APIName = this.entityToBePromoted.executor_name;
                                this.APIVersion = this.entityToBePromoted.executor_version;
                            }
                            Promise.resolve(this.platform.CheckForExistingEntityOrExecutorWithParams(this.target, this.targetAccount, this.targetPkey, this.APIName, this.APIVersion)).then(async resp => {
                                if (this.type === 'DATAACCESS' || this.type === 'SQLQUERY') {
                                    await this.getPartnerDatabases(loaderDialog);
                                    resolve('success');
                                    this.checkAuthenticityAndGetDatabasesCompleted = false;
                                    loaderDialog.close();
                                } else {
                                    this.checkAuthenticityAndGetDatabasesCompleted = false;
                                    loaderDialog.close();
                                    resolve('success');
                                }
                                this.isAPIAlreadyExists = false;
                            }, async error => {
                                if (error.status === 'already exists') {
                                    // this.platform.openSnackBar('An API with the provided name and version already exists in the target partner.', 'Error', {
                                    //   duration: 10000,
                                    //   verticalPosition: 'top',
                                    //   horizontalPosition: 'center'
                                    // });
                                    this.isAPIAlreadyExists = true;
                                    if (this.platform.existingEntity !== null && this.platform.existingEntity !== undefined && this.platform.existingEntity !== '') {
                                        this.existingAPI = this.platform.existingEntity;
                                    } else if (this.platform.existingExecutor !== null && this.platform.existingExecutor !== undefined && this.platform.existingExecutor !== '') {
                                        this.existingAPI = this.platform.existingExecutor;
                                    }
                                    resolve('already exists');

                                } else if (error.status === 'failed') {
                                    this.isAPIAlreadyExists = null;
                                    this.platform.openSnackBar('Error while checking API availability in target partner. Please try again after sometime.', 'Error', {
                                        duration: 10000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                    reject('failed');
                                }
                                await this.getPartnerDatabases(loaderDialog);
                                this.checkAuthenticityAndGetDatabasesCompleted = false;
                                loaderDialog.close();
                            });
                        } else {
                            this.targetPkey = '';
                            this.checkAuthenticityAndGetDatabasesCompleted = false;
                            this.platform.openSnackBar('Error while checking API availability in target partner. Please try again after sometime.', 'Error', {
                                duration: 10000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            reject('failed');
                        }
                    }, error => {
                        loaderDialog.close();
                        if (error.status === 401) {
                            this.platform.handleErrorGracefully(error, 'Invalid target partner. Please check the credentials.');
                            this.entityToBePromoted.database = '';
                        } else {
                            this.entityToBePromoted.database = '';
                            this.platform.handleErrorGracefully(error, 'Error while authenticating target partner. Please try again after sometime.');
                        }
                        this.targetPkey = '';
                        this.checkAuthenticityAndGetDatabasesCompleted = false;
                        reject(error);
                    });
                }
            }
        });
    }

    getGatewayItems(metaSchema, isExecutor) {
        return new Promise((resolve, reject) => {
            Promise.resolve(this.platform.getGatewayItems(this.partner, this.account, this.entity, this.version)).then(resp => {
                resolve('success');
            }, error => {
                if (error.status === 404) {
                    const data = {
                        entity: this.entity,
                        version: this.version,
                        partner: this.partner,
                        account: this.account,
                        methods: metaSchema['methods'],
                        isExecutor: isExecutor,
                        parentURL: this.router.url
                    };
                    const dialogRef = this.dialog.open(AddGatewayResourceComponent, {
                        width: 'auto',
                        height: 'auto',
                        data: data
                    });
                } else {
                    this.platform.handleErrorGracefully(error, 'Error while retrieving gateway resources. Please try again after sometime.');
                }
            });
        });
    }

    getPluginsForRoute(gatewayRoutes) {
        return new Promise((resolve, reject) => {
            this.kong.getPluginsForRouteInApiGateway(gatewayRoutes['data'][0]['name']).subscribe(async plugins => {
                let pluginsConfiguredForRoute = plugins['data'];
                resolve(pluginsConfiguredForRoute);
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while fetching plugins for the route from API Gateway. Please try after sometime.');
                this.router.navigateByUrl('/controlplane');
            });
        });
    }

    checkForAPIExistence(APIName, APIVersion, type) {
        return new Promise((resolve, reject) => {
            Promise.resolve(this.platform.CheckForExistingEntityOrExecutorWithParams(this.target, this.targetAccount, this.targetPkey, APIName, APIVersion)).then(async resp => {
                resolve('success');
            }, async error => {
                if (error.status === 'already exists') {
                    resolve('already exists');
                } else if (error.status === 'failed') {
                    this.platform.openSnackBar('Error while checking API availability in target partner. Please try again after sometime.', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    reject(error);
                } else {
                }
            });
        });
    }

    async promoteAPIWithIndex(dependentAPI, apiDependencies, APIName, APIVersion, type, i) {
        return new Promise(async (resolve, reject) => {
            const selectedDatabase = this.partnerDatabases.filter(db => db.database_name === dependentAPI.database);
            let continueOperation = false;
            let selectedDatabaseName: any;
            if (type === 'DATAACCESS' && selectedDatabase) {
                this.platform.publishEventMessage(APIName, APIVersion, 'API REQUIREMENTS', {
                    info: 'Validating target database',
                    type: 'initial',
                    icon: 'fa fa-newspaper-o'
                }, this.timeStamp, this.action);
                if (selectedDatabase.length) {
                    selectedDatabaseName = selectedDatabase[0].database_name;
                    continueOperation = true;
                    this.platform.publishEventMessage(APIName, APIVersion, 'API REQUIREMENTS', {
                        info: 'Validating target database',
                        type: 'success',
                        icon: 'fa fa-newspaper-o'
                    }, this.timeStamp, this.action);
                } else {
                    this.platform.publishEventMessage(APIName, APIVersion, 'API REQUIREMENTS', {
                        info: 'Validating target database',
                        type: 'fatal',
                        description: 'Invalid target database for ' + APIName + '(' + APIVersion + ')',
                        icon: 'fa fa-newspaper-o'
                    }, this.timeStamp, this.action);
                    this.apiDeploymentStatus[i].deployed = 'error';
                    this.apiDeploymentStatus[i].showQueryLogs = true;
                    resolve('failed');
                    // this.platform.openSnackBar('Invalid target database for ' + dependentAPI.entityname, 'Error', {
                    //     duration: 10000,
                    //     verticalPosition: 'top',
                    //     horizontalPosition: 'center'
                    // });
                }

            } else if (type !== 'DATAACCESS' && type !== 'SQLQUERY') {
                continueOperation = true;
            } else if (type === 'SQLQUERY') {
                const selectedDb = dependentAPI['executors'][0]['database']['database_name'] ? dependentAPI['executors'][0]['database']['database_name'] : '';
                const selectedDatabasesql = this.partnerDatabases.filter(db => db.database_name === selectedDb);
                selectedDatabaseName = selectedDb;
                this.platform.publishEventMessage(APIName, APIVersion, 'API REQUIREMENTS', {
                    info: 'Validating target database',
                    type: 'initial',
                    icon: 'fa fa-newspaper-o'
                }, this.timeStamp, this.action);
                if (selectedDatabasesql.length > 0) {
                    continueOperation = true;
                    this.platform.publishEventMessage(APIName, APIVersion, 'API REQUIREMENTS', {
                        info: 'Validating target database',
                        type: 'success',
                        icon: 'fa fa-newspaper-o'
                    }, this.timeStamp, this.action);
                } else {
                    this.platform.publishEventMessage(APIName, APIVersion, 'API REQUIREMENTS', {
                        info: 'Validating target database',
                        type: 'fatal',
                        description: 'Invalid target database for ' + APIName + '(' + APIVersion + ')',
                        icon: 'fa fa-newspaper-o'
                    }, this.timeStamp, this.action);
                    this.apiDeploymentStatus[i].deployed = 'error';
                    this.apiDeploymentStatus[i].showQueryLogs = true;
                    resolve('failed');
                    // this.platform.openSnackBar('Invalid target database for ' + dependentAPI.entityname, 'Error', {
                    //     duration: 10000,
                    //     verticalPosition: 'top',
                    //     horizontalPosition: 'center'
                    // });
                }
            }


            // if (continueOperation && type !== 'THIRDPARTY') {
            //     let apiExists = false;
            //
            //     await(this.platform.CheckForExistingEntityOrExecutorWithParams(this.target, this.targetAccount, this.targetPkey, APIName, APIVersion)).then(async resp => {
            //         apiExists = false;
            //     }, async error => {
            //         apiExists = true;
            //     });
            //     if (!apiDependencies.overrideAPIs.includes(i)) {
            //         this.platform.publishEventMessage(APIName, APIVersion, environment.pubsubtitles.API_REQUIREMENTS, {
            //             info: 'Checking for API existence',
            //             type: 'initial',
            //             icon: 'fa fa-check'
            //         }, this.timeStamp, this.action);
            //         if (apiExists) {
            //             this.platform.publishEventMessage(APIName, APIVersion, environment.pubsubtitles.API_REQUIREMENTS, {
            //                 info: 'Checking for API existence',
            //                 type: 'fatal',
            //                 description: 'An API with the provided name and version already exists. Check override option to override the existing API.',
            //                 icon: 'fa fa-check'
            //             }, this.timeStamp, this.action);
            //             this.apiDeploymentStatus[i].deployed = 'error';
            //             this.apiDeploymentStatus[i].showQueryLogs = true;
            //             resolve('failed');
            //         } else {
            //             this.platform.publishEventMessage(APIName, APIVersion, environment.pubsubtitles.API_REQUIREMENTS, {
            //                 info: 'Checking for API existence',
            //                 type: 'success',
            //                 icon: 'fa fa-check'
            //             }, this.timeStamp, this.action);
            //         }
            //
            //     }
            //
            //
            //     if ((!apiDependencies.overrideAPIs.includes(i) && !apiExists) || (apiDependencies.overrideAPIs.includes(i) && !apiExists)) {
            //
            //         if (!(type === 'THIRDPARTY' && dependentAPI.registeredAsIs)) {
            //             this.platform.publishEventMessage(APIName, APIVersion, 'API DEVELOPMENT', {
            //                 info: 'Retrieving Gateway configurations for the API',
            //                 type: 'initial',
            //                 icon: 'fa fa-edit'
            //             }, this.timeStamp, this.action);
            //             await Promise.resolve(this.platform.getGatewayItemsForEntity(this.partner, this.account, APIName, APIVersion)).then(async gatewaySettings => {
            //                 this.platform.publishEventMessage(APIName, APIVersion, 'API DEVELOPMENT', {
            //                     info: 'Retrieving Gateway configurations for the API',
            //                     type: 'success',
            //                     icon: 'fa fa-edit'
            //                 }, this.timeStamp, this.action);
            //                 const gatewayService = JSON.parse(JSON.stringify(gatewaySettings[0]));
            //                 const gatewayRoutes = JSON.parse(JSON.stringify(gatewaySettings[1]));
            //                 const gatewayPlugins = JSON.parse(JSON.stringify(gatewaySettings[2]));
            //                 if (type === 'DATAACCESS' && selectedDatabase) {
            //                     if (selectedDatabase.length) {
            //                         await this.promoteDependentAPI(dependentAPI, gatewayService, gatewayRoutes, gatewayPlugins, type, i, this.getEmailsAsArray(apiDependencies.permissionList[i].users.subtasks));
            //                         resolve('success');
            //                     } else {
            //                         this.apiDeploymentStatus[i].deployed = 'error';
            //                         this.apiDeploymentStatus[i].showQueryLogs = true;
            //                         resolve('failed');
            //                     }
            //
            //                 } else {
            //                     await this.promoteDependentAPI(dependentAPI, gatewayService, gatewayRoutes, gatewayPlugins, type, i, this.getEmailsAsArray(apiDependencies.permissionList[i].users.subtasks));
            //                     resolve('success');
            //                 }
            //             }, error => {
            //                 this.platform.publishEventMessage(APIName, APIVersion, 'API DEVELOPMENT', {
            //                     info: 'Retrieving Gateway configurations for the API',
            //                     type: 'fatal',
            //                     description: 'Gateway settings not found for this API in your account, Contact administrator.',
            //                     icon: 'fa fa-edit'
            //                 }, this.timeStamp, this.action);
            //                 this.apiDeploymentStatus[i].deployed = 'error';
            //                 this.apiDeploymentStatus[i].showQueryLogs = true;
            //                 resolve('failed');
            //             });
            //         } else {
            //             await this.promoteDependentAPIWithoutGateway(dependentAPI, type, i, this.getEmailsAsArray(apiDependencies.permissionList[i].users.subtasks));
            //             resolve('success');
            //         }
            //
            //
            //     } else if (apiDependencies.overrideAPIs.includes(i) && apiExists) {
            //         await this.updateDependentAPI(dependentAPI, type, i);
            //         resolve('success');
            //     }
            // } else {
            //     this.confPost.promoteAPI(this.partner, this.account, localStorage.getItem('partnerKey'), this.targetAccount, this.targetAccount, this.targetPkey, 'executor', apiDependencies.overrideAPIs.includes(i),
            //         {
            //             'gateway': 'kong',
            //             'baseUri': environment.adminGatewayHost,
            //             'apiHost': environment.apihostname,
            //             'apiName': APIName,
            //             'apiVersion': APIVersion,
            //             'email': this.getEmailsAsArray(apiDependencies.permissionList[i].users.subtasks)[0],
            //             'users': this.getEmailsAsArray(apiDependencies.permissionList[i].users.subtasks),
            //             'topic': this.partner + '.' + this.account + '.' + APIName + '.' + APIVersion + '.' + localStorage.getItem('sessionID') + '.' + this.timeStamp + '.' + this.action
            //         }).toPromise().then(response => {
            //
            //         this.apiDeploymentStatus[i].deployed = 'success';
            //         this.apiDeploymentStatus[i].showQueryLogs = true;
            //     }, error => {
            //         this.apiDeploymentStatus[i].deployed = 'error';
            //         this.apiDeploymentStatus[i].showQueryLogs = true;
            //     });
            // }

            if (continueOperation) {
                    this.confPost.promoteAPIWithCore(this.partner, this.account, localStorage.getItem('partnerKey'), {
                            topic: this.partner + '.' + this.account + '.' + APIName + '.' + APIVersion + '.' + localStorage.getItem('sessionID') + '.' + this.timeStamp + '.' + this.action,
                            promotionDetails: {
                                targetPartner: this.targetAccount,
                                targetAccount: this.targetAccount,
                                targetPkey: this.targetPkey,
                                apiName: APIName,
                                apiVersion: APIVersion,
                                database: selectedDatabaseName
                            }
                        }, apiDependencies.overrideAPIs.includes(i),
                    false, true).toPromise().then(response => {

                    this.apiDeploymentStatus[i].deployed = 'success';
                    this.apiDeploymentStatus[i].showQueryLogs = true;
                    resolve('success');
                }, error => {
                    this.apiDeploymentStatus[i].deployed = 'error';
                    this.apiDeploymentStatus[i].showQueryLogs = true;
                    resolve('failed');
                });
            }

        });
    }

    async promoteAPIs(apiDependencies) {
        this.apiDeploymentStatus = [];
        this.timeStamp = Date.now();
        this.action = this.renderType === 'copyAPI' ? 'copy' : 'promote';

        let rootAPIName = '';
        let rootAPIVersion = '';
        let rootAPIType = '';
        let rootType = 'DATAACCESS';
        const rootDependentAPI = apiDependencies.apiDependenciesList[0];
        if (apiDependencies.apiDependenciesList[0]['executor_name']) {
            rootType = apiDependencies.apiDependenciesList[0]['executor_type'];
        }


        // Check for list of dependencies
        if (apiDependencies.apiDependenciesList.length > 0) {
            // Publish message to the topic with title 'Dependency Analysis'
            // and message "Resolving Dependencies"


            if (rootType === 'DATAACCESS') {
                rootAPIName = apiDependencies.apiDependenciesList[0]['entityname'];
                rootAPIVersion = apiDependencies.apiDependenciesList[0]['version'];
                rootAPIType = rootType;
            } else {
                rootAPIName = apiDependencies.apiDependenciesList[0]['executor_name'];
                rootAPIVersion = apiDependencies.apiDependenciesList[0]['executor_version'];
                rootAPIType = rootType;
            }
            if (apiDependencies.apiDependenciesList[0] && apiDependencies.selectedAPIs.includes(0)) {

                this.apiDeploymentStatus.push({
                    deploying: true,
                    deployed: 'loading',
                    showQueryLogs: false,
                    apiName: rootAPIName,
                    apiVersion: rootAPIVersion,
                    apiType: rootAPIType,
                    timeStamp: this.timeStamp,
                    action: this.action
                });
                if (this.websocketService.isOpen()) {
                    this.apiDeploymentStatus[0].showQueryLogs = true;
                }
            } else {
                this.apiDeploymentStatus.push({
                    deploying: false,
                    deployed: 'loading',
                    showQueryLogs: false,
                    apiName: rootAPIName,
                    apiVersion: rootAPIVersion,
                    apiType: rootAPIType,
                    timeStamp: this.timeStamp,
                    action: this.action
                });
            }

            if (apiDependencies.apiDependenciesList.length > 1) {
                this.platform.publishEventMessage(rootAPIName, rootAPIVersion, 'API DEPENDENCIES', {
                    info: 'Resolving API Dependencies',
                    type: 'initialforquery',
                    icon: 'fa fa-newspaper-o'
                }, this.timeStamp, this.action);
            }
        }
        const promises = [];
        for (let i = 1; i < apiDependencies.apiDependenciesList.length; i++) {

            const dependentAPI = apiDependencies.apiDependenciesList[i];

            let type = 'DATAACCESS';
            if (dependentAPI['executor_name']) {
                type = dependentAPI['executor_type'];
            }
            let APIName = '';
            let APIVersion = '';
            let APIType = '';
            if (type === 'DATAACCESS') {
                APIName = dependentAPI['entityname'];
                APIVersion = dependentAPI['version'];
                APIType = type;
            } else {
                APIName = dependentAPI['executor_name'];
                APIVersion = dependentAPI['executor_version'];
                APIType = type;
            }

            if (apiDependencies.apiDependenciesList[i] && apiDependencies.selectedAPIs.includes(i)) {

                this.apiDeploymentStatus.push({
                    deploying: true,
                    deployed: 'loading',
                    showQueryLogs: false,
                    apiName: APIName,
                    apiVersion: APIVersion,
                    apiType: APIType,
                    timeStamp: this.timeStamp,
                    action: this.action
                });
                if (this.websocketService.isOpen()) {
                    this.apiDeploymentStatus[i].showQueryLogs = true;
                }
                promises.push(this.promoteAPIWithIndex(dependentAPI, apiDependencies, APIName, APIVersion, type, i));

            } else {
                this.apiDeploymentStatus.push({
                    deploying: false,
                    deployed: 'loading',
                    showQueryLogs: false,
                    apiName: APIName,
                    apiVersion: APIVersion,
                    apiType: APIType,
                    timeStamp: this.timeStamp,
                    action: this.action
                });
            }
        }

        Promise.all(promises)
            .then(async (results) => {
                if (apiDependencies.apiDependenciesList.length > 1) {
                    this.platform.publishEventMessage(rootAPIName, rootAPIVersion, 'API DEPENDENCIES', {
                        info: 'Resolving API Dependencies',
                        type: 'success',
                        icon: 'fa fa-newspaper-o'
                    }, this.timeStamp, this.action);
                }

                await this.promoteAPIWithIndex(rootDependentAPI, apiDependencies, rootAPIName, rootAPIVersion, rootType, 0);
            });
    }

    updateDependentAPI(entityToBePromoted, type, index) {
        return new Promise((resolve, reject) => {
            let APIName = '';
            let APIVersion = '';
            if (type === 'DATAACCESS') {
                APIName = entityToBePromoted['entityname'];
                APIVersion = entityToBePromoted['version'];
            } else {
                APIName = entityToBePromoted['executor_name'];
                APIVersion = entityToBePromoted['executor_version'];
            }
            entityToBePromoted['lastModifiedTime'] = Date.now();
            if (type === 'DATAACCESS') {
                this.platform.publishEventMessage(APIName, APIVersion, environment.pubsubtitles.API_DEPLOYMENT, {
                    info: 'Updating API Executor',
                    type: 'initial',
                    icon: 'fa fa-cloud-upload'
                }, this.timeStamp, this.action);
                this.confPost.updateEntityWithPkey(this.target, this.target, entityToBePromoted, this.targetPkey).subscribe(async data => {

                    this.platform.publishEventMessage(APIName, APIVersion, environment.pubsubtitles.API_DEPLOYMENT, {
                        info: 'Updating API Executor',
                        type: 'success',
                        icon: 'fa fa-cloud-upload'
                    }, this.timeStamp, this.action);

                    if (entityToBePromoted['published']) {
                        this.platform.publishEventMessage(APIName, APIVersion, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                            info: 'Updating Gateway Settings for the API',
                            type: 'initial',
                            icon: 'fa fa-shield'
                        }, this.timeStamp, this.action);
                        await this.kong.updateRouteWithMethods(this.target, this.target, entityToBePromoted['entityname'], entityToBePromoted['version'], entityToBePromoted.methods, this.timeStamp, this.action);
                        this.platform.publishEventMessage(APIName, APIVersion, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                            info: 'Updating Gateway Settings for the API',
                            type: 'success',
                            icon: 'fa fa-shield'
                        }, this.timeStamp, this.action);
                    }

                    this.platform.publishEventMessage(APIName, APIVersion, environment.pubsubtitles.API_DEPLOYMENT, {
                        info: 'Deploying API',
                        type: 'success',
                        icon: 'fa fa-cloud-upload'
                    }, this.timeStamp, this.action);

                    this.platform.publishEventMessage(APIName, APIVersion, environment.pubsubtitles.API_DOCUMENTATION, {
                        info: 'Generating Documentation',
                        type: 'initial',
                        icon: 'fa fa-book'
                    }, this.timeStamp, this.action);
                    await this.platform.delay(1000);
                    this.platform.publishEventMessage(APIName, APIVersion, environment.pubsubtitles.API_DOCUMENTATION, {
                        info: 'Generating Documentation',
                        type: 'success',
                        icon: 'fa fa-book'
                    }, this.timeStamp, this.action);

                    this.platform.publishEventMessage(APIName, APIVersion, environment.pubsubtitles.API_TESTING, {
                        info: 'Checking for testcases <br>Testcases found: 0',
                        icon: 'fa fa-check-square-o',
                        type: 'initial'
                    }, this.timeStamp, this.action);
                    await this.platform.delay(1000);
                    this.platform.publishEventMessage(APIName, APIVersion, environment.pubsubtitles.API_TESTING, {
                        info: 'Checking for testcases <br>Testcases found: 0',
                        icon: 'fa fa-check-square-o',
                        type: 'success'
                    }, this.timeStamp, this.action);

                    await this.platform.delay(1500);
                    this.platform.publishEventMessage(APIName, APIVersion, environment.pubsubtitles.DONE, {
                        info: '',
                        type: 'success',
                        icon: 'fa fa-check'
                    }, this.timeStamp, this.action);
                    this.apiDeploymentStatus[index].deployed = 'success';
                    this.apiDeploymentStatus[index].showQueryLogs = true;
                    resolve('success');
                }, error => {
                    let errorMessage = '';
                    if (error.error['message']) {
                        errorMessage = error.error.message;
                    } else {
                        errorMessage = error.error;
                    }
                    this.platform.publishEventMessage(APIName, APIVersion, environment.pubsubtitles.API_DEPLOYMENT, {
                        info: 'Updating API Executor',
                        type: 'fatal',
                        description: errorMessage,
                        icon: 'fa fa-cloud-upload'
                    }, this.timeStamp, this.action);
                    this.apiDeploymentStatus[index].deployed = 'error';
                    this.apiDeploymentStatus[index].showQueryLogs = true;
                    resolve('failed');
                });
            } else {
                this.platform.publishEventMessage(APIName, APIVersion, 'API DEVELOPMENT', {
                    info: 'Retrieving API information from target environment',
                    type: 'initial',
                    icon: 'fa fa-edit'
                }, this.timeStamp, this.action);
                this.confPost.getAPIExecutorForPartnerAccount(this.target, this.target, this.targetPkey, APIName, APIVersion).subscribe(async exec => {

                    entityToBePromoted['creationTime'] = exec['creationTime'];
                    entityToBePromoted['lastModifiedTime'] = Date.now();

                    this.platform.publishEventMessage(APIName, APIVersion, 'API DEVELOPMENT', {
                        info: 'Retrieving API information from target environment',
                        type: 'success',
                        icon: 'fa fa-edit'
                    }, this.timeStamp, this.action);

                    this.platform.publishEventMessage(APIName, APIVersion, 'API DEPLOYMENT', {
                        info: 'Updating API Executor',
                        type: 'initial',
                        icon: 'fa fa-cloud-upload'
                    }, this.timeStamp, this.action);
                    this.confPost.updateApiExecutorForPartnerAccountWithPkey(this.target, this.target, this.targetPkey, exec['id'], entityToBePromoted).subscribe(async data => {
                        this.platform.publishEventMessage(APIName, APIVersion, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                            info: 'Updating Gateway Settings for the API',
                            type: 'initial',
                            icon: 'fa fa-shield'
                        }, this.timeStamp, this.action);
                        await this.kong.updateRouteWithMethods(this.target, this.target, APIName, APIVersion, [entityToBePromoted.executor_method_type], this.timeStamp, this.action);
                        this.platform.publishEventMessage(APIName, APIVersion, environment.pubsubtitles.API_GATEWAY_MANAGEMENT, {
                            info: 'Updating Gateway Settings for the API',
                            type: 'success',
                            icon: 'fa fa-shield'
                        }, this.timeStamp, this.action);
                        this.platform.publishEventMessage(APIName, APIVersion, 'API DEPLOYMENT', {
                            info: 'Updating API Executor',
                            type: 'success',
                            icon: 'fa fa-cloud-upload'
                        }, this.timeStamp, this.action);

                        this.platform.publishEventMessage(APIName, APIVersion, 'API DEPLOYMENT', {
                            info: 'Deploying API',
                            type: 'initial',
                            icon: 'fa fa-cloud-upload'
                        }, this.timeStamp, this.action);
                        this.platform.publishEventMessage(APIName, APIVersion, 'API DEPLOYMENT', {
                            info: 'Deploying API',
                            type: 'success',
                            icon: 'fa fa-cloud-upload'
                        }, this.timeStamp, this.action);

                        this.platform.publishEventMessage(APIName, APIVersion, 'API DOCUMENTATION', {
                            info: 'Generating Documentation',
                            type: 'initial',
                            icon: 'fa fa-book'
                        }, this.timeStamp, this.action);
                        await this.platform.delay(1000);
                        this.platform.publishEventMessage(APIName, APIVersion, 'API DOCUMENTATION', {
                            info: 'Generating Documentation',
                            type: 'success',
                            icon: 'fa fa-book'
                        }, this.timeStamp, this.action);

                        this.platform.publishEventMessage(APIName, APIVersion, 'API TESTING', {
                            info: 'Checking for testcases <br>Testcases found: 0',
                            icon: 'fa fa-check-square-o',
                            type: 'initial'
                        }, this.timeStamp, this.action);
                        await this.platform.delay(1000);
                        this.platform.publishEventMessage(APIName, APIVersion, 'API TESTING', {
                            info: 'Checking for testcases <br>Testcases found: 0',
                            icon: 'fa fa-check-square-o',
                            type: 'success'
                        }, this.timeStamp, this.action);
                        await this.platform.delay(2000);
                        this.platform.publishEventMessage(APIName, APIVersion, 'DONE', {
                            info: '',
                            type: 'success',
                            icon: 'fa fa-check'
                        }, this.timeStamp, this.action);
                        this.apiDeploymentStatus[index].deployed = 'success';
                        this.apiDeploymentStatus[index].showQueryLogs = true;
                        resolve('success');
                    }, error => {

                        this.platform.publishEventMessage(APIName, APIVersion, 'API DEPLOYMENT', {
                            info: 'Updating API Executor',
                            type: 'error',
                            icon: 'fa fa-cloud-upload'
                        }, this.timeStamp, this.action);
                        this.apiDeploymentStatus[index].deployed = 'error';
                        this.apiDeploymentStatus[index].showQueryLogs = true;
                        resolve('failed');
                    });
                }, error1 => {
                    this.platform.publishEventMessage(APIName, APIVersion, 'API DEVELOPMENT', {
                            info: 'Retrieving API information from target environment',
                            description: 'Error while retrieving executor: ' + error1.error['message'],
                            type: 'fatal',
                            icon: 'fa fa-edit'
                        },
                        this.timeStamp, this.action);
                    this.apiDeploymentStatus[index].deployed = 'error';
                    this.apiDeploymentStatus[index].showQueryLogs = true;
                    resolve('failed');
                });

            }
        });
    
    }

    promoteDependentAPIWithoutGateway(entityToBePromoted, type, index, emails) {
        return new Promise(async (resolve, reject) => {

            this.progress = 0;
            let APIName = '';
            let APIVersion = '';
            if (type === 'DATAACCESS') {
                APIName = entityToBePromoted['entityname'];
                APIVersion = entityToBePromoted['version'];
            } else {
                APIName = entityToBePromoted['executor_name'];
                APIVersion = entityToBePromoted['executor_version'];
            }
            const entity = {
                entityName: APIName,
                version: APIVersion,
                action: this.action,
                timeStamp: this.timeStamp
            };

            entityToBePromoted['creationTime'] = Date.now();
            entityToBePromoted['lastModifiedTime'] = Date.now();

            this.platform.insertExecutor(this.target, this.target, this.targetPkey, entityToBePromoted).then(async resp => {
                this.platform.publishEventMessage(entity.entityName, entity.version, 'API DEPLOYMENT', {
                    info: 'Setting up API',
                    type: 'success',
                    icon: 'fa fa-edit'
                }, this.timeStamp, this.action);
                this.deploymentResults = resp;
                this.showStatusPanel = true;
                this.loading = false;
                await this.platform.generateAccountRolePermissionGroupAndPermissionsForUsers(this.target, this.target, emails, entityToBePromoted.executor_name, entityToBePromoted.executor_version, 'BUSINESSLOGIC', true, this.timeStamp, this.action);

                this.platform.publishEventMessage(entity.entityName, entity.version, 'API DOCUMENTATION', {
                    info: 'Generating Documents',
                    type: 'initial',
                    icon: 'fa fa-book'
                }, this.timeStamp, this.action);
                await this.platform.delay(1000);
                this.platform.publishEventMessage(entity.entityName, entity.version, 'API DOCUMENTATION', {
                    info: 'Generating Documents',
                    type: 'success',
                    icon: 'fa fa-book'
                }, this.timeStamp, this.action);
                await this.platform.delay(1000);
                this.platform.publishEventMessage(entity.entityName, entity.version, 'DONE', {
                    info: '',
                    type: 'success',
                    icon: 'fa fa-check'
                }, this.timeStamp, this.action);
                this.apiDeploymentStatus[index].deployed = 'success';
                this.apiDeploymentStatus[index].showQueryLogs = true;
                resolve('success');
            }, error => {
                this.loading = false;
                this.platform.publishEventMessage(entity.entityName, entity.version, 'API DEPLOYMENT', {
                    info: 'Setting up API',
                    type: 'fatal',
                    description: 'Error while setting up API configurations. Contact Admin or try again later.',
                    icon: 'fa fa-edit'
                }, this.timeStamp, this.action);
                this.apiDeploymentStatus[index].deployed = 'error';
                this.apiDeploymentStatus[index].showQueryLogs = true;
                resolve('failed');
            });

        });
    }

    getEmailsAsArray(val) {
        const emailArray = [];
        for (const obj of val) {
            if (obj.email && obj.completed) {
                emailArray.push(obj.email);
            }
        }
        return emailArray;
    }

    promoteDependentAPI(entityToBePromoted, gatewayService, gatewayRoutes, gatewayPlugins, type, index, emails) {
        return new Promise(async (resolve, reject) => {
            let gatewayRoute = {
                data: []
            };
            this.progress = 0;
            let APIName = '';
            let APIVersion = '';
            if (type === 'DATAACCESS') {
                APIName = entityToBePromoted['entityname'];
                APIVersion = entityToBePromoted['version'];
            } else {
                APIName = entityToBePromoted['executor_name'];
                APIVersion = entityToBePromoted['executor_version'];
            }
            const entity = {
                entityName: APIName,
                version: APIVersion,
                action: this.action,
                timeStamp: this.timeStamp
            };
            if (this.target !== null && this.target !== undefined && this.target !== '') {
                this.loading = true;
                const partnerArray = this.partner.split('-');
                var targetPartner = this.partner;
                if (partnerArray.length > 0) {
                    delete gatewayService['id'];
                    if (gatewayRoutes.data) {
                        gatewayRoutes.data.forEach(async route => {
                            if (route && route !== null && route !== undefined) {

                                //this.gatewayRoute.data = [];

                                const temp = route['name'].split('-');


                                let routeName = '';
                                if (temp[temp.length - 1] === 'GET' || temp[temp.length - 1] === 'POST' || temp[temp.length - 1] === 'PUT' || temp[temp.length - 1] === 'PATCH' || temp[temp.length - 1] === 'DELETE' || temp[temp.length - 1] === 'OPTIONS') {
                                    routeName = this.target + '-' + this.targetAccount + '-' + APIName + '-' + APIVersion + '-' + temp[temp.length - 1];
                                } else {
                                    routeName = this.target + '-' + this.targetAccount + '-' + APIName + '-' + APIVersion;
                                }

                                const routeObject = {
                                    name: routeName,
                                    protocols: ['https', 'http'],
                                    hosts: [await this.platform.getTargetPartnerDefaultGatewayURL(this.target, this.targetAccount, false)],
                                    paths: route['paths'],
                                    methods: route['methods']
                                };

                                if (entityToBePromoted.hasOwnProperty('methods')) {
                                    if (temp[temp.length - 1] === 'OPTIONS') {
                                        if (entityToBePromoted['methods'].includes('POST') === false) {
                                            if (routeObject.methods.includes('POST') === false) {
                                                routeObject.methods.push('POST');
                                            }
                                        }
                                    }
                                } else if (entityToBePromoted.hasOwnProperty('executor_method_type')) {
                                    if (temp[temp.length - 1] === 'OPTIONS') {
                                        if (entityToBePromoted['executor_method_type'] !== 'POST') {
                                            if (routeObject.methods.includes('POST') === false) {
                                                routeObject.methods.push('POST');
                                            }
                                        }
                                    }
                                }

                                gatewayRoute.data.push(routeObject);
                            }
                        });
                    }

                    entityToBePromoted['creationTime'] =  Date.now();
                    entityToBePromoted['lastModifiedTime'] =  entityToBePromoted['creationTime'];
                    if (type === 'DATAACCESS') {
                        gatewayService['name'] = this.target + '-' + this.targetAccount + '-' + entityToBePromoted.entityname + '-' + entityToBePromoted.version;
                        gatewayService['path'] = '/' + entityToBePromoted.version + '/data/' + this.target + '/' + this.targetAccount + '/' + entityToBePromoted.entityname;
                        if (entityToBePromoted.database && entityToBePromoted.database !== '') {
                            const selectedDatabase = this.targetDatabases.filter(db => db.database_name === entityToBePromoted.database);
                            if (selectedDatabase['is_nosql'] === false) {
                                await this.checkForExistingTable();
                            }
                            entityToBePromoted['tableCreation'] = true;
                            if (entityToBePromoted['published']) {
                                this.platform.publishEventMessage(APIName, APIVersion, 'API DEPLOYMENT', {
                                    info: 'Configuring Gateway settings for API',
                                    type: 'initial',
                                    icon: 'fa fa-edit'
                                }, this.timeStamp, this.action);
                                this.platform.configureAPIGatewaySettingsWithMethods(gatewayService, gatewayRoute, this.platform.constructKeyValueGatewayConfigurations('promote', this.target, gatewayPlugins['data']), entity).then(async gatewayResponse => {
                                    this.platform.publishEventMessage(APIName, APIVersion, 'API DEPLOYMENT', {
                                        info: 'Configuring Gateway settings for API',
                                        type: 'success',
                                        icon: 'fa fa-edit'
                                    }, this.timeStamp, this.action);
                                    this.platform.publishEventMessage(APIName, APIVersion, 'API DEPLOYMENT', {
                                        info: 'Setting up API',
                                        type: 'initial',
                                        icon: 'fa fa-edit'
                                    }, this.timeStamp, this.action);
                                    this.platform.insertEntity(this.target, this.targetAccount, this.targetPkey, entityToBePromoted).then(async resp => {
                                        this.platform.publishEventMessage(APIName, APIVersion, 'API DEPLOYMENT', {
                                            info: 'Setting up API',
                                            type: 'success',
                                            icon: 'fa fa-edit'
                                        }, this.timeStamp, this.action);
                                        this.deploymentResults = resp;
                                        this.showStatusPanel = true;
                                        this.loading = false;
                                        await this.platform.generateAccountRolePermissionGroupAndPermissionsForUsers(this.target, this.targetAccount, emails, entityToBePromoted.entityname, entityToBePromoted.version, 'DAAS', true, this.timeStamp, this.action);
                                        this.platform.publishEventMessage(APIName, APIVersion, 'API DOCUMENTATION', {
                                            info: 'Generating Documents',
                                            type: 'initial',
                                            icon: 'fa fa-book'
                                        }, this.timeStamp, this.action);
                                        await this.platform.delay(1000);
                                        this.platform.publishEventMessage(APIName, APIVersion, 'API DOCUMENTATION', {
                                            info: 'Generating Documents',
                                            type: 'success',
                                            icon: 'fa fa-book'
                                        }, this.timeStamp, this.action);
                                        await this.platform.delay(1000);
                                        this.platform.publishEventMessage(APIName, APIVersion, 'DONE', {
                                            info: '',
                                            type: 'success',
                                            icon: 'fa fa-check'
                                        }, this.timeStamp, this.action);
                                        this.apiDeploymentStatus[index].deployed = 'success';
                                        this.apiDeploymentStatus[index].showQueryLogs = true;
                                        this.loading = false;
                                        resolve('success');
                                    }, error => {
                                        this.platform.publishEventMessage(APIName, APIVersion, 'API DEPLOYMENT', {
                                            info: 'Setting up API',
                                            type: 'fatal',
                                            description: 'Error while setting up API configurations. Contact Admin or try again later.',
                                            icon: 'fa fa-edit'
                                        }, this.timeStamp, this.action);
                                        this.loading = false;
                                        this.apiDeploymentStatus[index].deployed = 'error';
                                        this.apiDeploymentStatus[index].showQueryLogs = true;
                                        resolve('failed');
                                    });
                                }, error => {
                                    this.platform.publishEventMessage(APIName, APIVersion, 'API DEPLOYMENT', {
                                        info: 'Configuring Gateway settings for API',
                                        type: 'fatal',
                                        description: 'Error while configuring API Gateway. Please try again sometime.',
                                        icon: 'fa fa-edit'
                                    }, this.timeStamp, this.action);
                                    this.apiDeploymentStatus[index].deployed = 'error';
                                    this.apiDeploymentStatus[index].showQueryLogs = true;
                                    resolve('failed');
                                });
                            } else {
                                this.platform.publishEventMessage(APIName, APIVersion, 'API DEPLOYMENT', {
                                    info: 'Setting up API',
                                    type: 'initial',
                                    icon: 'fa fa-edit'
                                }, this.timeStamp, this.action);
                                this.platform.insertEntity(this.target, this.targetAccount, this.targetPkey, entityToBePromoted).then(async resp => {
                                    this.platform.publishEventMessage(APIName, APIVersion, 'API DEPLOYMENT', {
                                        info: 'Setting up API',
                                        type: 'success',
                                        icon: 'fa fa-edit'
                                    }, this.timeStamp, this.action);
                                    this.deploymentResults = resp;
                                    // this.kongService.configureApiGateway(this.target, this.account, this.entityToBePromoted.entityname, this.entityToBePromoted.version);
                                    this.showStatusPanel = true;
                                    this.loading = false;
                                    await this.platform.generateAccountRolePermissionGroupAndPermissionsForUsers(this.target, this.targetAccount, emails, entityToBePromoted.entityname, entityToBePromoted.version, 'DAAS', true, this.timeStamp, this.action);
                                    this.platform.publishEventMessage(APIName, APIVersion, 'API DOCUMENTATION', {
                                        info: 'Generating Documents',
                                        type: 'initial',
                                        icon: 'fa fa-book'
                                    }, this.timeStamp, this.action);
                                    await this.platform.delay(1000);
                                    this.platform.publishEventMessage(APIName, APIVersion, 'API DOCUMENTATION', {
                                        info: 'Generating Documents',
                                        type: 'success',
                                        icon: 'fa fa-book'
                                    }, this.timeStamp, this.action);
                                    await this.platform.delay(1000);
                                    this.platform.publishEventMessage(APIName, APIVersion, 'DONE', {
                                        info: '',
                                        type: 'success',
                                        icon: 'fa fa-check'
                                    }, this.timeStamp, this.action);
                                    this.apiDeploymentStatus[index].deployed = 'success';
                                    this.apiDeploymentStatus[index].showQueryLogs = true;
                                    // this.manageProgressId = setInterval(() => this.manageProgress(), 1000);
                                    resolve('success');
                                }, error => {
                                    this.platform.publishEventMessage(APIName, APIVersion, 'API DEPLOYMENT', {
                                        info: 'Setting up API',
                                        type: 'fatal',
                                        description: 'Error while setting up API configurations. Contact Admin or try again later.',
                                        icon: 'fa fa-edit'
                                    }, this.timeStamp, this.action);
                                    this.loading = false;
                                    this.apiDeploymentStatus[index].deployed = 'error';
                                    this.apiDeploymentStatus[index].showQueryLogs = true;
                                });
                            }
                        } else {
                            this.platform.publishEventMessage(APIName, APIVersion, 'API REQUIREMENTS', {
                                info: 'Validating target database',
                                type: 'fatal',
                                description: 'Invalid target database for ' + APIName + '(' + APIVersion + ')',
                                icon: 'fa fa-newspaper-o'
                            }, this.timeStamp, this.action);
                            // this.platform.openSnackBar('Please choose a target database.', 'Error', {
                            //     duration: 10000,
                            //     verticalPosition: 'top',
                            //     horizontalPosition: 'center'
                            // });
                            this.loading = false;
                            this.apiDeploymentStatus[index].deployed = 'error';
                            this.apiDeploymentStatus[index].showQueryLogs = true;
                            resolve('failed');
                        }
                    } else {
                        // entityToBePromoted['account_id'] = this.target;
                        // if (type !== '"THIRDPARTY"') {
                        //     entityToBePromoted['apiUrl'] = 'https://' + this.target + '.gateway.apiplatform.io/' + entityToBePromoted['executor_version'] + '/' + entityToBePromoted['executor_name'];
                        // }
                        gatewayService['name'] = this.target + '-' + this.targetAccount + '-' + entityToBePromoted.executor_name + '-' + entityToBePromoted.executor_version;
                        gatewayService['path'] = '/' + this.target + '/' + this.targetAccount + '/' + entityToBePromoted.executor_version + '/' + entityToBePromoted.executor_name;
                        if (type === 'SQLQUERY') {
                            const selectedDatabase = this.partnerDatabases.filter(db => db.database_name === entityToBePromoted['executors'][0]['database']['database_name']);
                            if (entityToBePromoted['executors'][0]['database']['database_name'] && entityToBePromoted['executors'][0]['database']['database_name'] !== '' && selectedDatabase.length > 0) {
                                const status = await this.promoteDependentExecutor(entityToBePromoted, gatewayService, gatewayRoute, gatewayPlugins, this.timeStamp, emails);
                                if (status === 'success') {
                                    this.apiDeploymentStatus[index].deployed = 'success';
                                } else {
                                    this.apiDeploymentStatus[index].deployed = 'error';
                                }
                                this.apiDeploymentStatus[index].showQueryLogs = true;
                                resolve('success');
                            } else {
                                this.platform.publishEventMessage(APIName, APIVersion, 'API REQUIREMENTS', {
                                    info: 'Validating target database',
                                    type: 'fatal',
                                    description: 'Invalid target database for ' + APIName + '(' + APIVersion + ')',
                                    icon: 'fa fa-newspaper-o'
                                }, this.timeStamp, this.action);
                                // this.platform.openSnackBar('Please choose a target database.', 'Error', {
                                //     duration: 10000,
                                //     verticalPosition: 'top',
                                //     horizontalPosition: 'center'
                                // });
                                this.loading = false;
                                this.apiDeploymentStatus[index].showQueryLogs = true;
                                this.apiDeploymentStatus[index].deployed = 'error';
                                resolve('failed');
                            }
                        } else {
                            const status = await this.promoteDependentExecutor(entityToBePromoted, gatewayService, gatewayRoute, gatewayPlugins, this.timeStamp, emails);
                            if (status === 'success') {
                                this.apiDeploymentStatus[index].deployed = 'success';
                            } else {
                                this.apiDeploymentStatus[index].deployed = 'error';
                            }
                            this.apiDeploymentStatus[index].showQueryLogs = true;
                            resolve('success');
                        }
                    }
                } else {
                    this.loading = false;
                    this.platform.publishEventMessage(APIName, APIVersion, 'API REQUIREMENTS', {
                        info: 'Validating partner environment',
                        type: 'fatal',
                        description: 'You can not promote from this environment',
                        icon: 'fa fa-newspaper-o'
                    }, this.timeStamp, this.action);
                    // this.platform.openSnackBar('You can not promote from this environment', 'Error', {
                    //     duration: 10000,
                    //     verticalPosition: 'top',
                    //     horizontalPosition: 'center'
                    // });
                    this.apiDeploymentStatus[index].deployed = 'error';
                    this.apiDeploymentStatus[index].showQueryLogs = true;
                    resolve('failed');
                }
            } else {
                this.platform.publishEventMessage(APIName, APIVersion, 'API REQUIREMENTS', {
                    info: 'Validating partner environment',
                    type: 'fatal',
                    description: 'Please choose a target environment and provide target partner key.',
                    icon: 'fa fa-newspaper-o'
                }, this.timeStamp, this.action);
                // this.platform.openSnackBar('Please choose a target environment and provide target partner key.', 'Error', {
                //     duration: 10000,
                //     verticalPosition: 'top',
                //     horizontalPosition: 'center'
                // });
                this.loading = false;
                this.apiDeploymentStatus[index].deployed = 'error';
                this.apiDeploymentStatus[index].showQueryLogs = true;
                resolve('failed');
            }
        });
    }


    async promoteAPI() {
        this.progress = 0;
        if (this.target !== null && this.target !== undefined && this.target !== '') {
            this.loading = true;
            const partnerArray = this.partner.split('-');
            var targetPartner = this.partner;
            let APIName = '';
            let APIVersion = '';
            if (this.type === 'DATAACCESS') {
                APIName = this.entityToBePromoted['entityname'];
                APIVersion = this.entityToBePromoted['version'];
            } else {
                APIName = this.entityToBePromoted['executor_name'];
                APIVersion = this.entityToBePromoted['executor_version'];
            }
            if (partnerArray.length > 1) {
                delete this.platform.gatewayService['id'];
                if (this.platform.gatewayRoutes.data) {
                    this.platform.gatewayRoutes.data.forEach(async route => {
                        if (route && route !== null && route !== undefined) {


                            this.gatewayRoute.data = [];
                            const routeObject = {
                                name: this.target + '-' + this.target + '-' + APIName + '-' + APIVersion + '-path',
                                protocols: ['https', 'http'],
                                hosts: [await this.platform.getTargetPartnerDefaultGatewayURL(this.target, this.target, false)],
                                paths: route['paths'],
                                methods: route['methods']
                            };
                            this.gatewayRoute.data.push(routeObject);
                        }
                    });
                }
                targetPartner = this.target + '-' + partnerArray[1];
                this.entityToBePromoted['partner'] = this.target;
                if (this.type === 'DATAACCESS') {
                    this.entityToBePromoted['account'] = this.target;
                    this.platform.gatewayService['name'] = this.target + '-' + this.target + '-' + this.entityToBePromoted.entityname + '-' + this.entityToBePromoted.version;
                    this.platform.gatewayService['path'] = '/' + this.APIVersion + '/data/' + this.target + '/' + this.target + '/' + this.entityToBePromoted.entityname;
                    if (this.entityToBePromoted.database !== undefined && this.entityToBePromoted.database !== null && this.entityToBePromoted.database !== '') {
                        // this.confPost.insertEntityForPartner(this.target, this.account, this.targetPkey, this.entityToBePromoted).subscribe(data => {
                        //   this.deploymentResults = data;
                        //   this.kongService.configureApiGateway(this.target, this.account, this.entityToBePromoted.entityname, this.entityToBePromoted.version);
                        //   this.showStatusPanel = true;
                        //   this.loading = false;
                        //   setInterval(() => this.manageProgress(), 1000);
                        // }, error => {
                        //   this.loading = false;
                        //   this.platform.openSnackBar('Error in creating API from deployment plan. Please try again after sometime.', 'Error', {
                        //     duration: 10000,
                        //     verticalPosition: 'top',
                        //     horizontalPosition: 'center'
                        //   });
                        // });
                        const entity = {
                            entityName: this.entityToBePromoted['executor_name'],
                            version: this.entityToBePromoted['executor_version'],
                            action: this.action,
                            timeStamp: this.timeStamp
                        };
                        const selectedDatabase = this.targetDatabases.filter(db => db.database_name === this.entityToBePromoted.database);
                        if (selectedDatabase['is_nosql'] === false) {
                            await this.checkForExistingTable();
                        }
                        this.entityToBePromoted['tableCreation'] = true;
                        if (this.entityToBePromoted['published']) {
                            this.platform.configureAPIGatewaySettingsWithMethods(this.platform.gatewayService, this.gatewayRoute, this.platform.constructKeyValueGatewayConfigurations('promote', this.entityToBePromoted['partner'], this.platform.gatewayPlugins['data']), entity).then(async gatewayResponse => {
                                this.platform.insertEntity(this.target, this.target, this.targetPkey, this.entityToBePromoted).then(async resp => {
                                    this.deploymentResults = resp;
                                    // this.kongService.configureApiGateway(this.target, this.account, this.entityToBePromoted.entityname, this.entityToBePromoted.version);
                                    this.showStatusPanel = true;
                                    this.loading = false;
                                    await this.platform.generateAccountRolePermissionGroupAndPermissions(this.target, this.target, localStorage.getItem('signInEmail'), this.entity, this.version, 'DAAS', true, this.timeStamp, this.action);
                                    this.platform.publishEventMessage(APIName, APIVersion, 'API DOCUMENTATION', {
                                        info: 'Generating Documents',
                                        type: 'initial',
                                        icon: 'fa fa-book'
                                    }, this.timeStamp, this.action);
                                    await this.platform.delay(1000);
                                    this.platform.publishEventMessage(APIName, APIVersion, 'API DOCUMENTATION', {
                                        info: 'Generating Documents',
                                        type: 'success',
                                        icon: 'fa fa-book'
                                    }, this.timeStamp, this.action);
                                    await this.platform.delay(1000);
                                    this.platform.publishEventMessage(APIName, APIVersion, 'DONE', {
                                        info: '',
                                        type: 'success',
                                        icon: 'fa fa-check'
                                    }, this.timeStamp, this.action);
                                    // this.manageProgressId = setInterval(() => this.manageProgress(), 1000);
                                }, error => {
                                    this.loading = false;
                                });
                            }, error => {
                                this.loading = false;
                                this.platform.handleErrorGracefully(error, 'Error while configuring API Gateway. Please try again sometime.');
                            });
                        } else {
                            this.platform.insertEntity(this.target, this.target, this.targetPkey, this.entityToBePromoted).then(async resp => {
                                this.deploymentResults = resp;
                                // this.kongService.configureApiGateway(this.target, this.account, this.entityToBePromoted.entityname, this.entityToBePromoted.version);
                                this.showStatusPanel = true;
                                this.loading = false;
                                await this.platform.generateAccountRolePermissionGroupAndPermissions(this.target, this.target, localStorage.getItem('signInEmail'), this.entity, this.version, 'DAAS', true, this.timeStamp, this.action);
                                this.platform.publishEventMessage(APIName, APIVersion, 'API DOCUMENTATION', {
                                    info: 'Generating Documents',
                                    type: 'initial',
                                    icon: 'fa fa-book'
                                }, this.timeStamp, this.action);
                                await this.platform.delay(1000);
                                this.platform.publishEventMessage(APIName, APIVersion, 'API DOCUMENTATION', {
                                    info: 'Generating Documents',
                                    type: 'success',
                                    icon: 'fa fa-book'
                                }, this.timeStamp, this.action);
                                await this.platform.delay(1000);
                                this.platform.publishEventMessage(APIName, APIVersion, 'DONE', {
                                    info: '',
                                    type: 'success',
                                    icon: 'fa fa-check'
                                }, this.timeStamp, this.action);
                                // this.manageProgressId = setInterval(() => this.manageProgress(), 1000);
                            }, error => {
                                this.loading = false;
                            });
                        }
                    } else {
                        this.platform.openSnackBar('Please choose a target database.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        this.loading = false;
                    }
                } else {
                    this.entityToBePromoted['account_id'] = this.target;
                    this.platform.gatewayService['name'] = this.target + '-' + this.target + '-' + this.entityToBePromoted.executor_name + '-' + this.entityToBePromoted.executor_version;
                    this.platform.gatewayService['path'] = '/' + this.target + '/' + this.target + '/' + this.entityToBePromoted.executor_version + '/' + this.entityToBePromoted.executor_name;
                    if (this.type === 'SQLQUERY') {
                        if (this.entityToBePromoted['executors'][0]['database']['databaseDetails']['database_name'] !== undefined && this.entityToBePromoted['executors'][0]['database']['databaseDetails']['database_name'] !== null && this.entityToBePromoted['executors'][0]['database']['databaseDetails']['database_name'] !== '') {
                            this.promoteExecutor();
                        } else {
                            this.platform.openSnackBar('Please choose a target database.', 'Error', {
                                duration: 10000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            this.loading = false;
                        }
                    } else {
                        this.promoteExecutor();
                    }
                }
            } else {
                this.loading = false;
                this.platform.openSnackBar('You can not promote from this environment', 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        } else {
            this.platform.openSnackBar('Please choose a target environment and provide target partner key.', 'Error', {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.loading = false;
        }
    }

    checkForOverrideAndPromote() {
        if (this.replaceApi === true) {
            if (this.isAPIAlreadyExists === true) {
                if (this.existingAPI.hasOwnProperty('entityname')) {
                    Promise.resolve(this.platform.deleteApiWithDependencies(true, true, true, this.target, this.target, this.targetPkey, this.entityToBePromoted['entityname'], this.entityToBePromoted['version'])).then(resp => {
                        this.promoteAPI();
                    });
                } else {
                    Promise.resolve(this.platform.deleteExecutorWithDependencies(true, true, true, this.target, this.target, this.targetPkey, this.entityToBePromoted['executor_name'], this.entityToBePromoted['executor_version'], this.entityToBePromoted['executor_type'])).then(resp => {
                        this.promoteAPI();
                    });
                }
            } else {
                this.promoteAPI();
            }
        } else {
            if (this.isAPIAlreadyExists === true) {
                const dialogRef = this.dialog.open(OverrideExistingAPIComponent, {
                    width: 'auto',
                    height: 'auto',
                    data: {
                        existingAPI: this.existingAPI,
                        type: this.type
                    }
                });
                dialogRef.afterClosed().subscribe(async data => {
                    if (data && data !== undefined) {
                        if (data === 'yes') {
                            if (this.existingAPI.hasOwnProperty('entityname')) {
                                await Promise.resolve(this.platform.deleteApiWithDependencies(true, true, true, this.target, this.target, this.targetPkey, this.existingAPI['entityname'], this.existingAPI['version'])).then(resp => {
                                    this.promoteAPI();
                                });
                            } else {
                                await Promise.resolve(this.platform.deleteExecutorWithDependencies(true, true, true, this.target, this.target, this.targetPkey, this.existingAPI['executor_name'], this.existingAPI['executor_version'], this.existingAPI['executor_type'])).then(resp => {
                                    this.promoteAPI();
                                });
                            }
                        }
                    }
                });
            } else {
                this.promoteAPI();
            }
        }
    }

    async promoteApi() {
        if (this.target && this.target !== null && this.target !== undefined && this.target !== '' && this.targetPkey && this.targetPkey !== null && this.targetPkey !== undefined && this.targetPkey !== '') {
            if (this.checkAuthenticityAndGetDatabasesCompleted === false) {
                Promise.resolve(this.checkAuthenticityAndGetDatabases()).then(async resp => {
                    this.checkForOverrideAndPromote();
                });
            } else {
                this.checkForOverrideAndPromote();
            }
        } else {
            this.platform.openSnackBar('Please make sure you have provided both the target partner environment and target partner key.', 'Error', {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    promoteExecutor() {
        // this.confPost.insertApiExecutorForPartner(this.target, this.account, this.targetPkey, this.entityToBePromoted).subscribe(data => {
        //   this.deploymentResults = data;
        //   this.kongService.configureApiGateway(this.target, this.account, this.entityToBePromoted.entityname, this.entityToBePromoted.version);
        //   this.showStatusPanel = true;
        //   this.loading = false;
        //   setInterval(() => this.manageProgress(), 1000);
        // }, error => {
        //   this.loading = false;
        //   this.platform.openSnackBar('Error in creating API from deployment plan. Please try again after sometime.', 'Error', {
        //     duration: 10000,
        //     verticalPosition: 'top',
        //     horizontalPosition: 'center'
        //   });
        // });

        return new Promise(async (resolve, reject) => {
            this.entityToBePromoted['apiUrl'] = 'https://' + await this.platform.getTargetPartnerDefaultGatewayURL(this.target, this.target, false) +  '/' + this.entityToBePromoted['executor_name'] + '/' + this.entityToBePromoted['executor_version'];
            const entity = {
                entityName: this.entityToBePromoted['executor_name'],
                version: this.entityToBePromoted['executor_version'],
                action: this.action,
                timeStamp: this.timeStamp
            };
            Promise.resolve(this.platform.configureAPIGatewaySettingsWithMethods(this.platform.gatewayService, this.gatewayRoute, this.platform.constructKeyValueGatewayConfigurations('promote', this.target, this.platform.gatewayPlugins['data']), entity)).then(async gatewayResponse => {
                this.platform.insertExecutor(this.target, this.target, this.targetPkey, this.entityToBePromoted).then(resp => {
                    this.deploymentResults = resp;
                    // this.kongService.configureApiGateway(this.target, this.account, this.entityToBePromoted.entityname, this.entityToBePromoted.version);
                    this.showStatusPanel = true;
                    this.loading = false;
                    setInterval(() => this.manageProgress(), 1000);
                    resolve('success');
                }, error => {
                    this.loading = false;
                    this.platform.openSnackBar('Error in creating API from deployment plan. Please try again after sometime.', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    resolve('failed');
                });
            }, error => {
                this.loading = false;
                this.platform.handleErrorGracefully(error, 'Error while configuring API Gateway. Please try again sometime.');
                resolve('failed');
            });
        });
    }

    promoteDependentExecutor(entityToBePromoted, gatewayService, gatewayRoute, gatewayPlugins, timeStamp, emails) {
        return new Promise((resolve, reject) => {
            // entityToBePromoted['apiUrl'] = 'https://' + this.target + '.gateway.apiplatform.io/' + entityToBePromoted['executor_version'] + '/' + entityToBePromoted['executor_name'];
            const entity = {
                entityName: entityToBePromoted['executor_name'],
                version: entityToBePromoted['executor_version'],
                action: this.action,
                timeStamp: this.timeStamp
            };
            // const headers = [];
            //
            // if (entityToBePromoted['headers']) {
            //     for (const val of entityToBePromoted['headers']) {
            //         if (val.key && (val.key === 'apikey' || val.key === 'pkey')) {
            //             val['value'] = '';
            //         }
            //         headers.push(val);
            //     }
            // }
            //
            // entityToBePromoted['headers'] = headers;
            entityToBePromoted['creationTime'] = Date.now();
            entityToBePromoted['lastModifiedTime'] = Date.now();
            this.platform.publishEventMessage(entity.entityName, entity.version, 'API DEPLOYMENT', {
                info: 'Configuring Gateway settings for API',
                type: 'initial',
                icon: 'fa fa-edit'
            }, this.timeStamp, this.action);

            Promise.resolve(this.platform.configureAPIGatewaySettingsWithMethods(gatewayService, gatewayRoute, this.platform.constructKeyValueGatewayConfigurations('promote', this.target, gatewayPlugins['data']), entity)).then(async gatewayResponse => {
                this.platform.publishEventMessage(entity.entityName, entity.version, 'API DEPLOYMENT', {
                    info: 'Configuring Gateway settings for API',
                    type: 'success',
                    icon: 'fa fa-edit'
                }, this.timeStamp, this.action);
                this.platform.publishEventMessage(entity.entityName, entity.version, 'API DEPLOYMENT', {
                    info: 'Setting up API',
                    type: 'initial',
                    icon: 'fa fa-edit'
                }, this.timeStamp, this.action);
                this.platform.insertExecutor(this.target, this.target, this.targetPkey, entityToBePromoted).then(async resp => {
                    this.platform.publishEventMessage(entity.entityName, entity.version, 'API DEPLOYMENT', {
                        info: 'Setting up API',
                        type: 'success',
                        icon: 'fa fa-edit'
                    }, this.timeStamp, this.action);
                    this.deploymentResults = resp;
                    // this.kongService.configureApiGateway(this.target, this.account, this.entityToBePromoted.entityname, this.entityToBePromoted.version);
                    this.showStatusPanel = true;
                    this.loading = false;
                    await this.platform.generateAccountRolePermissionGroupAndPermissionsForUsers(this.target, this.target, emails, entityToBePromoted.executor_name, entityToBePromoted.executor_version, 'BUSINESSLOGIC', true, timeStamp, this.action);

                    this.platform.publishEventMessage(entity.entityName, entity.version, 'API DOCUMENTATION', {
                        info: 'Generating Documents',
                        type: 'initial',
                        icon: 'fa fa-book'
                    }, this.timeStamp, this.action);
                    await this.platform.delay(1000);
                    this.platform.publishEventMessage(entity.entityName, entity.version, 'API DOCUMENTATION', {
                        info: 'Generating Documents',
                        type: 'success',
                        icon: 'fa fa-book'
                    }, this.timeStamp, this.action);
                    await this.platform.delay(1000);
                    this.platform.publishEventMessage(entity.entityName, entity.version, 'DONE', {
                        info: '',
                        type: 'success',
                        icon: 'fa fa-check'
                    }, this.timeStamp, this.action);
                    // this.apiDeploymentStatus[index].deployed = 'success';
                    // this.apiDeploymentStatus[index].showQueryLogs = true;
                    // this.manageProgressId = setInterval(() => this.manageProgress(), 1000);
                    this.loading = false;
                    resolve('success');
                    // setInterval(() => this.manageProgress(), 1000);
                    resolve('success');
                }, error => {
                    this.loading = false;
                    this.platform.publishEventMessage(entity.entityName, entity.version, 'API DEPLOYMENT', {
                        info: 'Setting up API',
                        type: 'fatal',
                        description: 'Error while setting up API configurations. Contact Admin or try again later.',
                        icon: 'fa fa-edit'
                    }, this.timeStamp, this.action);
                    // this.platform.openSnackBar('Error in creating API from deployment plan. Please try again after sometime.', 'Error', {
                    //     duration: 10000,
                    //     verticalPosition: 'top',
                    //     horizontalPosition: 'center'
                    // });
                    resolve('failed');
                });
            }, error => {
                this.loading = false;
                this.platform.publishEventMessage(entity.entityName, entity.version, 'API DEPLOYMENT', {
                    info: 'Configuring Gateway settings for API',
                    type: 'fatal',
                    description: 'Error while configuring API Gateway. Please try again sometime.',
                    icon: 'fa fa-edit'
                }, this.timeStamp, this.action);
                // this.platform.handleErrorGracefully(error, 'Error while configuring API Gateway. Please try again sometime.');
                resolve('failed');
            });
        });
    }

    getPartnerDatabaseConnections(index) {
        if (this.apiDependenciesList[index].database) {
            const dataTypeFilter = this.getDatabaseTypeForDatabaseName(this.apiDependenciesList[index].database);
            let targetDatabases = [];
            this.partnerDatabases.forEach(db => {
                if (db && db !== null && db !== undefined) {
                    if (db['database_type'] === dataTypeFilter) {
                        targetDatabases.push(db);
                    }
                }
            });
            return targetDatabases;
        }

    }

    dependentAPIs(apis) {
        let tabData = {};
        this.apiDependenciesList = apis;
        tabData['type'] = 'dataAccessAPIs';
        tabData['selectedEntityPlan'] = this.apiDependenciesList[0];
        tabData['blocklyRendered'] = false;
        tabData['index'] = 0;
        this.renderedDataAccessAPIs.push(0);
        this.tabData.push(tabData);
    }

    onItemSelected(index) {
        if (!this.renderedDataAccessAPIs.includes(index)) {
            let tabData = {};
            tabData['type'] = 'dataAccessAPIs';
            tabData['selectedEntityPlan'] = this.apiDependenciesList[index];
            tabData['blocklyRendered'] = false;
            tabData['index'] = index;
            this.renderedDataAccessAPIs.push(index);
            this.tabData.push(tabData);
            this.activeTabIndex = this.tabData.length - 1;
        }
    }

    closeTab(index) {
        const apiIndex = this.renderedDataAccessAPIs.indexOf(this.tabData[index].index);
        this.renderedDataAccessAPIs.splice(apiIndex, 1);
        this.tabData.splice(index, 1);
        this.activeTabIndex = this.tabData.length - 1;
    }

}

@Component({
    selector: 'override-existing-api',
    templateUrl: 'override-existing-api.component.html',
    styleUrls: ['override-existing-api.component.css']
})
export class OverrideExistingAPIComponent implements OnInit {

    APIName: string;
    APIVersion: string;
    type: any;

    constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any,
                public platform: LeftpanelComponent,
                public dialogRef: MatDialogRef<OverrideExistingAPIComponent>,
                public confPost: ConfService,
                public router: Router,
                public kongService: KongService) {
        dialogRef.disableClose = true;
    }

    ngOnInit() {
        if (this.data.hasOwnProperty('type') && this.data.hasOwnProperty('existingAPI')) {
            if (this.data.existingAPI.hasOwnProperty('entityname')) {
                this.APIName = this.data.existingAPI['entityname'];
                this.APIVersion = this.data.existingAPI['version'];
                this.type = 'DATAACCESS';
            } else {
                this.APIName = this.data.existingAPI['executor_name'];
                this.APIVersion = this.data.existingAPI['executor_version'];
                this.type = this.data.existingAPI['executor_type'];
            }
        }
    }

    proceed() {
        this.dialogRef.close('yes');
    }

    close() {
        this.dialogRef.close('no');
    }

}
